export default __webpack_public_path__ + "static/media/mobilePlaceholder.9750d2ef.webp";